
import { defineComponent, computed, ref, Ref, inject, watch, nextTick } from "vue";
import { store } from "@/store";
import CloseSVG from "@/components/CloseSVG.vue";
import { SheetLabel, ClientDimensions } from "@/types";
import { ActionTypes } from "@/store/actions";

export default defineComponent({
  name: "PrintingHelp",
  components: {
    CloseSVG,
  },
  setup() {
    const closeModal = inject("closeModal") as () => void;
    const bounceTransition = inject("bounceTransition") as Ref<string>;
    const fadeTransition = inject("fadeTransition") as Ref<string>;

    const openPrintingIssues = () => {
      store.dispatch(ActionTypes.SET_MODAL, "troubleShooting");
    };

    const currentLabel = computed<SheetLabel>(() => store.getters.currentLabel);
    const clientDimensions = computed<ClientDimensions>(() => store.getters.clientDimensions);

    const size = ref<HTMLInputElement>();
    const scale = ref<HTMLInputElement>();
    const weight = ref<HTMLInputElement>();
    const loaded = ref<HTMLInputElement>();

    const sizeStep = ref(false);
    const scaleStep = ref(false);
    const weightStep = ref(false);
    const loadedStep = ref(false);

    const allStepsChecked = computed<boolean>(
      () => sizeStep.value && scaleStep.value && weightStep.value && loadedStep.value
    );

    watch(clientDimensions, async (newDimension, oldDimension) => {
      const newWidth = newDimension.width;
      const oldWidth = oldDimension.width;

      if ((newWidth <= 767 && oldWidth > 767) || (newWidth > 767 && oldWidth <= 767)) {
        await nextTick();
        handleResize();
      }
    });

    const handleResize = () => {
      setInputChecked(size, sizeStep);
      setInputChecked(scale, scaleStep);
      setInputChecked(weight, weightStep);
      setInputChecked(loaded, loadedStep);
    };

    const setInputChecked = (element: Ref<HTMLInputElement | undefined>, step: Ref<boolean>) => {
      if (element.value) {
        step.value ? (element.value.checked = true) : (element.value.checked = false);
      }
    };

    const handleChange = (step: string) => {
      switch (step) {
        case "size": {
          sizeStep.value = !sizeStep.value;
          break;
        }
        case "scale": {
          scaleStep.value = !scaleStep.value;
          break;
        }
        case "weight": {
          weightStep.value = !weightStep.value;
          break;
        }
        case "loaded": {
          loadedStep.value = !loadedStep.value;
          break;
        }
      }
    };

    return {
      size,
      scale,
      weight,
      loaded,
      sizeStep,
      scaleStep,
      weightStep,
      loadedStep,
      allStepsChecked,
      currentLabel,
      clientDimensions,
      bounceTransition,
      fadeTransition,
      closeModal,
      openPrintingIssues,
      handleChange,
    };
  },
});
